// Marchio.tsx — la scritta «LAUGH DOWN» come nell'icona dello store (v019): «LAUGH» giallo-arancio, «DOWN» bianco,
// contorno blu notte spesso, la «O» è una faccina che ride con le lacrime. Due strati di testo: sotto il contorno,
// sopra il riempimento sfumato. Resta latino (da sinistra a destra) in tutte le lingue.
import { MARCHIO } from "../costanti.ts";

function Strati({ testo, classe }: { testo: string; classe: string }) {
  return (
    <span className="ld-strati" aria-hidden="true">
      <span className="ld-contorno">{testo}</span>
      <span className={classe}>{testo}</span>
    </span>
  );
}

/** La «O» che ride (si muove; ferma con «riduci animazioni»). */
export function FacciaO({ classe = "ld-o" }: { classe?: string }) {
  return (
    <svg className={classe} viewBox="0 0 62 62" aria-hidden="true">
      <circle cx="31" cy="31" r="27" fill="#FFFFFF" stroke="#1B1F4B" strokeWidth="7" />
      <path d="M17 26 Q21 20 25 26 M37 26 Q41 20 45 26" stroke="#1B1F4B" strokeWidth="3.6" fill="none" strokeLinecap="round" />
      <path d="M18 33 Q31 52 44 33 Z" fill="#1B1F4B" />
      <path d="M24 41 Q31 47 38 41 Q31 44 24 41Z" fill="#FF4D4D" />
      <path d="M10 30 q-4 6 0 9 q4-3 0-9Z" fill="#3DA9FF" />
      <path d="M52 30 q-4 6 0 9 q4-3 0-9Z" fill="#3DA9FF" />
    </svg>
  );
}

export function Marchio({ dimensione = "grande", animato = true }: { dimensione?: "grande" | "medio" | "piccolo"; animato?: boolean }) {
  return (
    <h1 className={`ld-marchio ld-marchio-${dimensione}${animato ? " ld-animato" : ""}`} aria-label={MARCHIO}>
      <Strati testo="LAUGH" classe="ld-oro" />
      <span className="ld-riga">
        <Strati testo="D" classe="ld-bianco" />
        <FacciaO />
        <Strati testo="WN" classe="ld-bianco" />
      </span>
    </h1>
  );
}

/** Titolo grande in stile marchio (es. «HAI VINTO!»): colore «oro» o «rosso». */
export function TitoloMarchio({ testo, colore }: { testo: string; colore: "oro" | "rosso" }) {
  return (
    <p className="ld-titolo-marchio" role="status">
      <span className="ld-strati">
        <span className="ld-contorno" aria-hidden="true">
          {testo}
        </span>
        <span className={colore === "oro" ? "ld-oro" : "ld-rosso"}>{testo}</span>
      </span>
    </p>
  );
}
